import { Stethoscope } from 'lucide-react';

import { useMyDosespotClinicianInfoQuery } from '@/entities/dosespot-clinician';
import { cn } from '@/lib/utils';

/**
 * Displays the prescriber's registered demographic info per ACR S.103.1:
 * "Sender demographic information, when included in the message, shall
 * match what was registered by the customer in the Surescripts Directory."
 *
 * Shows the clinician's name and address as registered in DoseSpot,
 * which corresponds to their SureScripts Directory entry.
 */
export function PrescriberInfo() {
  const clinicianQuery = useMyDosespotClinicianInfoQuery();
  const info = clinicianQuery.data;

  if (!info) return null;

  const fullName = [info.Prefix, info.FirstName, info.LastName, info.Suffix]
    .filter(Boolean)
    .join(' ');
  const cityStateZip =
    [info.City, info.State].filter(Boolean).join(', ') + (info.ZipCode ? ` ${info.ZipCode}` : '');

  return (
    <div
      className={cn(
        'rounded-lg border border-border/60 bg-muted/30 p-3',
        'dark:border-border/40 dark:bg-muted/20'
      )}
    >
      <div className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
        <Stethoscope className="size-3.5" aria-hidden />
        Prescriber
      </div>
      <div className="grid grid-cols-1 gap-1 @md:grid-cols-2">
        <div>
          <div className="text-[10px] uppercase tracking-wide text-muted-foreground">Name</div>
          <div className="text-xs font-medium">{fullName}</div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-wide text-muted-foreground">Address</div>
          <div className="text-xs font-medium">{info.Address1}</div>
          {cityStateZip ? <div className="text-xs font-medium">{cityStateZip}</div> : null}
        </div>
      </div>
    </div>
  );
}
